import React from "react";
import Notice from "../components/general/Notice";

export const LinkExpired = (): React.ReactElement => {
  return <Notice title={"Link Expired"} message={"Your email verification link has expired"}/>
}

export default LinkExpired;
